import { render, staticRenderFns } from "./curriculum.vue?vue&type=template&id=7cb19a2e&"
import script from "./curriculum.vue?vue&type=script&lang=js&"
export * from "./curriculum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports